import { Rate, Input, Divider, Button, Form, notification } from "antd";
import React from "react";
import WebUtils from "../utils/WebUtils";
import { feedbackPostApi } from "../../api";
// import "../../styles/endInterview.css";
const { TextArea } = Input;

function FeedbackEndInterview({ interviewId, setLoading, setCompletionData }) {
  const [form] = Form.useForm();

  const PostApi = (data) => {
    let req = {
      clarityOfQuestions: data.clarity,
      aiResponsiveness: data.responsiveness,
      platformUsability: data.usability,
      description: data.feedback || "",
    };

    setLoading(true);
    const url = `${feedbackPostApi}?interviewId=${interviewId}`;

    WebUtils.httpOperations(url, req, "POST")
      .then((result) => {
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          notification.success({
            description: `Feedback submitted`,
            // icon: <Icon type="green-tick" />,
            placement: "topRight",
            showProgress: true,
          });

          setCompletionData((prevData) => ({
            ...prevData,
            candidateReviewExist: true,
          }));

          //   setLoading(false);
        } else {
          notification.warning({
            description: `Feedback submition failed`,
            // icon: <Icon type="green-tick" />,
            placement: "topRight",
            showProgress: true,
          });
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  // Handle form submission
  const onFinish = (values) => {
    // console.log("Form Data:", values);

    PostApi(values);
  };

  // Handle form submission failure (if validation fails)
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <>
      <div className="w-full mt-2">
        <p className="text-2xl text-[#FDB022] font-semibold text-center">
          Thank You for Completing the Assessment
        </p>
        <p className="text-center">
          We appreciate your time and effort. Please provide your feedback below
        </p>
      </div>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <div className="w-full text-white">
          {/* <div> */}
          <div className="flex flex-wrap justify-center gap-2">
            <p className="w-[200px] flex justify-start">
              Clarity of Questions <span className="text-[#206DC5]">*</span>
            </p>
            <Form.Item
              name="clarity"
              className="p-0 m-0 "
              rules={[
                {
                  required: true,
                  message: " clarity of questions required!",
                },
              ]}
            >
              <Rate allowHalf className="rate-svg" />
            </Form.Item>
          </div>

          {/* AI Responsiveness */}
          <div className="flex flex-wrap justify-center gap-2 mt-2 ">
            <p className="w-[200px] flex">
              AI Responsiveness <span className="text-[#206DC5]">*</span>
            </p>
            <Form.Item
              name="responsiveness"
              className="p-0 m-0 "
              rules={[
                { required: true, message: "AI responsiveness required!" },
              ]}
            >
              <Rate allowHalf className="rate-svg" />
            </Form.Item>
          </div>

          {/* Platform Usability */}
          <div className="flex flex-wrap justify-center gap-2 mt-2 ">
            <p className="w-[200px] flex">
              Platform Usability <span className="text-[#206DC5]">*</span>
            </p>
            <Form.Item
              name="usability"
              className="p-0 m-0 "
              rules={[
                { required: true, message: "platform usability required!" },
              ]}
            >
              <Rate allowHalf className="rate-svg" />
            </Form.Item>
            {/* </div> */}
          </div>

          {/* Feedback Text Area */}
          <div className="mt-6 w-full text-center">
            <Form.Item
              name="feedback"
              rules={[
                { max: 100, message: "Feedback cannot exceed 100 characters." },
              ]}
            >
              <TextArea
                placeholder="Enter your feedback here..."
                style={{
                  height: 120,
                  resize: "none",
                  width: 450,
                }}
              />
            </Form.Item>

            <p className="sm:w-[90%] md:w-[500px] m-auto">
              <Divider className="bg-white" />
            </p>

            {/* Submit and Cancel Buttons */}
            <div className="flex flex-wrap gap-4 justify-center">
              <button
                className="cancel-btn"
                onClick={(e) => {
                  form.resetFields();
                  e.preventDefault();
                }}
              >
                Cancel
              </button>
              <button className="submit-btn" htmlType="submit">
                Submit
              </button>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
}

export default FeedbackEndInterview;
